// extracted by mini-css-extract-plugin
export var alignCenter = "_ah-d";
export var bannerShown = "_ah-6";
export var buttonContent = "_ah-0";
export var cardList = "_ah-1";
export var centerContent = "_ah-2";
export var chevron = "_ah-3";
export var closePanelButton = "_ah-k";
export var conversationContextContainer = "_ah-l";
export var conversationDetailContainer = "_ah-4";
export var detailWrapper = "_ah-7";
export var dropdownButton = "_ah-e";
export var dropdownTitle = "_ah-9";
export var fullHeight = "_ah-5";
export var hidden = "_ah-a";
export var icon = "_ah-b";
export var mergeSuggestionWrapper = "_ah-m";
export var panel = "_ah-i";
export var portalButtonsWrapper = "_ah-c";
export var right = "_ah-j";
export var tableSummaryContainer = "_ah-8";
export var tableSummaryHeader = "_ah-g";
export var threeDotsButton = "_ah-f";
export var wide = "_ah-h";